"use client"

import React, { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { cn } from '@/utils/index'

type ItemTypes = {
  id: string
  name: string
  description?: string
}

type DropdownMenuProps = {
  items: ItemTypes[]
  label: string
  value: ItemTypes
  className?: string
  onChange(value: ItemTypes): void
}

export const Dropdown = ({ items, label, value, className, onChange }: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Menu as="div" className={cn(`dropdown relative ${className}`)}>
      <MenuButton onClick={() => setIsOpen(!isOpen)} className="dropdown-btn">
        <p className="text-[15px] font-light text-gray-400">{label}</p>
        <div className="dropdown-label">
          <div className="text-[18px] font-medium leading-tight">{value.name}</div>
          {isOpen ? (
            <ChevronUp className="dropdown-icon-secondary" />
          ) : (
            <ChevronDown className="dropdown-icon-secondary" />
          )}
        </div>
      </MenuButton>

      <MenuItems className="dropdown-menu space-y-1 py-1">
        {items.map((item) => (
          <MenuItem
            key={item.id}
            as="li"
            onClick={() => onChange(item)}
            className={({ active }) =>
              cn(
                "cursor-pointer px-3 py-2 rounded transition",
                active ? "bg-gray-100 dark:bg-gray-800" : "",
                value.id === item.id ? "text-dark-blue font-medium" : "text-gray-700 dark:text-gray-300"
              )
            }
          >
            <div className="flex flex-col text-left">
              <span className="text-[15px]">{item.name}</span>
              {item.description && (
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {item.description}
                </span>
              )}
            </div>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}
